import { BUSINESS } from '@/lib/businessConfig';

const P = BUSINESS.pricing;

// Single source for the homepage FAQ: the visible accordion (HomeAtelier) and the
// FAQPage JSON-LD (SEOHead → getHomeFaqSchema) both read this list, so they never drift.
// Written as direct, self-contained answers — the form AI assistants quote and cite.
export const HOME_FAQ = [
  {
    question: 'Τι υπηρεσίες προσφέρει το Ikonomakis Hair Atelier;',
    answer: 'Γυναικείο και ανδρικό κούρεμα ακριβείας, bespoke βαφή μαλλιών, balayage, babylights, blonde specialist, color correction, κερατίνη, K18, Hair Botox, Milbon 360° και ανάλυση προσώπου Face Metrics Pro (προσωπομετρία & προσωπολογία).',
  },
  {
    question: 'Πόσο κοστίζουν οι υπηρεσίες;',
    answer: `Ενδεικτικές τιμές «από»: γυναικείο ή ανδρικό κούρεμα €${P.haircutFrom}, βαφή €${P.colorFrom}, balayage €${P.balayageFrom}, κερατίνη €${P.keratinFrom}, K18 €${P.k18From}, Milbon 360° €${P.milbonFrom}, Face Metrics Pro στο atelier €${P.faceMetricsAtelier} (45 λεπτά). Η τελική τιμή εξαρτάται από το μήκος, την πυκνότητα και το επίπεδο ειδικότητας του stylist.`,
  },
  {
    question: 'Πού βρίσκεται το κομμωτήριο;',
    answer: `${BUSINESS.address.street}, ${BUSINESS.address.locality} ${BUSINESS.address.postalCode}, Αττική — στα Βόρεια Προάστια της Αθήνας.`,
  },
  {
    question: 'Πώς κλείνω ραντεβού;',
    answer: `Online μέσω Fresha (κουμπί «Κράτηση Online» στο ikonomakis.gr) με άμεση επιβεβαίωση, ή τηλεφωνικά στο ${BUSINESS.phone}. Λειτουργούμε μόνο με ραντεβού.`,
  },
  {
    question: 'Ποιο είναι το ωράριο;',
    answer: 'Τρίτη, Πέμπτη και Παρασκευή 10:00–20:00, Τετάρτη και Σάββατο 09:00–17:00. Κυριακή και Δευτέρα κλειστά.',
  },
  {
    question: 'Από ποιες περιοχές έρχονται οι πελάτες σας;',
    answer: 'Κυρίως από Χαλάνδρι, Φιλοθέη, Ψυχικό, Νέο Ψυχικό, Χολαργό, Παπάγου, Αγία Παρασκευή, Βριλήσσια, Μελίσσια, Μαρούσι και Κηφισιά, αλλά και από όλη την Αθήνα.',
  },
  {
    question: 'Τι είναι το Face Metrics Pro;',
    answer: `Ανάλυση προσώπου με AI (προσωπομετρία) που μετρά αναλογίες, συμμετρία και σχήμα προσώπου, ώστε να επιλεγεί το κούρεμα και το χρώμα που ταιριάζει. Στο atelier γίνεται με τον Θοδωρή Οικονομάκη, €${BUSINESS.faceMetrics.atelier.price} / ${BUSINESS.faceMetrics.atelier.minutes} λεπτά.`,
  },
  {
    question: 'Ποια η διαφορά προσωπολογίας και προσωπομετρίας;',
    answer: 'Η προσωπομετρία μετρά αντικειμενικά αναλογίες, συμμετρία και σχήμα προσώπου με το Face Metrics Pro AI. Η προσωπολογία (visagisme) ερμηνεύει τι εκφράζει το πρόσωπο και ποια εικόνα θέλετε να περνάτε. Στο atelier συνδυάζονται: η προσωπομετρία δίνει τις μετρήσεις, η προσωπολογία το νόημα.',
  },
  {
    question: 'Πόση εμπειρία έχετε;',
    answer: `30+ χρόνια, 2η γενιά κομμωτών, εκπαιδεύσεις σε 19 χώρες. Αξιολόγηση ${BUSINESS.reviews.summaryEl} στο Fresha.`,
  },
  {
    question: 'Προσφέρετε υπηρεσίες για άνδρες;',
    answer: 'Ναι — ανδρικό κούρεμα ακριβείας (scissor & fade), ανδρική βαφή και ανδρική περμανάντ, σχεδιασμένα με βάση το σχήμα προσώπου.',
  },
];
